<template>
	<div>
		<svg :width="size" :height="size"  viewBox="0 0 14 14" :fill="color" xmlns="http://www.w3.org/2000/svg">
			<path fill-rule="evenodd" clip-rule="evenodd" d="M11.4564 4.92638C12.13 5.15561 12.7362 5.1205 13.0939 4.76265C13.7649 4.09152 13.3121 2.551 12.0824 1.32167C10.8534 0.0923346 9.31287 -0.360538 8.64251 0.3103C8.28438 0.66796 8.24907 1.27406 8.4783 1.94783L6.67874 3.74711C5.8029 3.20783 4.94088 2.91302 4.23711 2.91302C3.75915 2.91302 3.35445 3.04826 3.06844 3.33428C2.25393 4.14869 2.66336 5.92563 3.94399 7.61522C3.9487 7.6215 3.95357 7.62781 3.95848 7.63415C3.96274 7.63967 3.96703 7.64522 3.97125 7.65081C4.04441 7.7463 4.11899 7.84152 4.19783 7.93625C4.21839 7.96113 4.2397 7.9857 4.26098 8.01022C4.27331 8.02443 4.28562 8.03862 4.29777 8.05286C4.30769 8.06443 4.31759 8.076 4.32749 8.08757C4.37827 8.14694 4.42894 8.20618 4.48233 8.26495C4.58521 8.37834 4.69149 8.49078 4.80242 8.6017C4.89961 8.6989 4.99804 8.79241 5.09723 8.88374C5.11522 8.90018 5.13327 8.91622 5.15129 8.93222C5.1621 8.94182 5.17289 8.95141 5.18364 8.96106C5.25652 9.02665 5.32968 9.09091 5.40331 9.15329C5.43398 9.17912 5.46445 9.20439 5.49512 9.22966C5.57244 9.29355 5.65005 9.35535 5.72785 9.41526C5.73118 9.41788 5.73451 9.42051 5.73785 9.42314C5.75856 9.43947 5.7793 9.45583 5.80025 9.47148C6.89254 10.2967 8.02098 10.7572 8.90098 10.7572C9.37894 10.7572 9.78363 10.622 10.0696 10.336C10.7762 9.62878 10.5607 8.197 9.65558 6.72661L11.4564 4.92638ZM0.0157189 13.2505C-0.040033 13.3403 0.0635844 13.444 0.153416 13.3882L5.20477 10.2533C4.82998 9.969 4.46172 9.64968 4.10803 9.29571C3.75037 8.93805 3.43426 8.5696 3.15193 8.19727L0.0157189 13.2505Z" fill="#0055A3"/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgPinned',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null
		}
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		}
	}
};
</script>

<style scoped></style>